import React from 'react';
import { searchCustomers } from 'utils/CustomersAPIUtils';
import { FilterAutocompleteEditor } from 'components/design-system/molecules/FilterAutocompleteEditor';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
function getCustomerName(item) {
    switch (item._type) {
        case 'Partner':
        case 'Carrier':
            return item.name || '';
        case 'Shipper':
        case 'Vendor':
            return item.company_name || '';
        default:
            return `${item.first_name || ''} ${item.last_name || ''}`.trim();
    }
}
const searchAllCustomers = async (query) => {
    const results = (await searchCustomers({
        queryText: query,
        customerTypes: ['carriers', 'shippers'],
    }));
    return results.sort((a, b) => getCustomerName(a).localeCompare(getCustomerName(b)));
};
const USER_TYPE_OPTIONS = [
    { label: 'Carrier', value: 'carrier' },
    { label: 'Shipper', value: 'shipper' },
];
const STATUS_OPTIONS = [
    { label: 'Confirmed', value: 'confirmed' },
    { label: 'Awaiting', value: 'awaiting' },
    { label: 'Expired', value: 'expired' },
    { label: 'Declined', value: 'declined' },
];
const LEG_TYPE_OPTIONS = [
    { label: 'Full Container', value: 'full_container' },
    { label: 'Empty Container', value: 'empty_container' },
    { label: 'Chassis Split', value: 'chassis_split' },
    { label: 'Bobtail', value: 'bobtail' },
    { label: 'Dry Run', value: 'dry_run' },
];
const AUTO_APPLY_OPTIONS = [
    { label: 'Enabled', value: 'enabled' },
    { label: 'Disabled', value: 'disabled' },
];
export function makeAccessorialRatesFilters({ markets, accessorials, }) {
    return [
        {
            id: 'customer_type',
            label: 'User Type',
            kind: 'select-multi',
            initialValue: [],
            options: USER_TYPE_OPTIONS,
            toApiParam: { name: 'customerType' },
        },
        {
            id: 'customer',
            label: 'Customer',
            kind: 'autocomplete-multi',
            initialValue: [],
            toApiParam: { name: 'customer' },
            render: (ctx) => (React.createElement(FilterAutocompleteEditor, { onSearch: searchAllCustomers, toItem: (c) => ({
                    id: c._id,
                    label: getCustomerName(c),
                    description: c.email || c._type,
                }), value: ctx.value || [], labels: ctx.labels, onAdd: ctx.onAdd, onRemove: ctx.onRemove, placeholder: "Search for customer..." })),
        },
        {
            id: 'market',
            label: 'Market',
            kind: 'select-multi',
            initialValue: [],
            options: markets.map((m) => ({
                label: m.name,
                value: m.name,
            })),
            toApiParam: { name: 'market' },
        },
        {
            id: 'status',
            label: 'Status',
            kind: 'select-multi',
            initialValue: [],
            options: STATUS_OPTIONS,
            toApiParam: { name: 'status' },
        },
        {
            id: 'accessorialtype',
            label: 'Accessorial Type',
            kind: 'select-single',
            initialValue: null,
            options: accessorials.map((a) => ({
                label: a.name,
                value: a.slug || a._id,
            })),
            toApiParam: { name: 'accessorialtype' },
        },
        {
            id: 'legType',
            label: 'Leg Type',
            kind: 'select-single',
            initialValue: null,
            options: LEG_TYPE_OPTIONS,
            toApiParam: { name: 'legType' },
        },
        {
            id: 'auto_apply',
            label: 'Auto Apply',
            kind: 'select-single',
            initialValue: null,
            options: AUTO_APPLY_OPTIONS,
            featureFlag: () => featureEnabled(CONFIGURED_FEATURES === null || CONFIGURED_FEATURES === void 0 ? void 0 : CONFIGURED_FEATURES.AUTO_APPLY_ACCESSORIAL),
            toApiParam: {
                name: 'autoApply',
                transform: (v) => {
                    if (v === 'enabled')
                        return true;
                    if (v === 'disabled')
                        return false;
                    return undefined;
                },
            },
        },
    ];
}
export const EMPTY_FILTER_DEPS = {
    markets: [],
    accessorials: [],
};
